export const siteStats = [
  { id: 's1', icon: 'ri-inbox-archive-line', value: '37', unit: '条', label: '今日新增投稿' },
  { id: 's2', icon: 'ri-shield-check-line', value: '12', unit: '条', label: '已核实线索' },
  { id: 's3', icon: 'ri-group-line', value: '186', unit: '万', label: '累计吃瓜群众' },
  { id: 's4', icon: 'ri-folder-2-line', value: '4', unit: '类', label: '内容分区' },
];

export const submitChannels = [
  {
    id: 'text',
    icon: 'ri-file-text-line',
    name: '文字线索',
    desc: '直接用文字描述时间、地点与事件经过，越具体越容易被采纳。',
    tips: '建议附上大致日期与场所',
  },
  {
    id: 'chat',
    icon: 'ri-chat-history-line',
    name: '聊天记录',
    desc: '截图请尽量保留完整对话上下文，避免只截取单条信息造成误读。',
    tips: '请对无关隐私信息打码',
  },
  {
    id: 'video',
    icon: 'ri-video-line',
    name: '视频素材',
    desc: '支持短视频与现场片段，投稿时请注明拍摄时间与镜头来源。',
    tips: '原始文件比二次转发更可靠',
  },
  {
    id: 'photo',
    icon: 'ri-image-2-line',
    name: '现场图片',
    desc: '现场目击照片、后台画面等均可，多张照片请按时间顺序标注。',
    tips: '请勿裁剪关键信息区域',
  },
];

export const submitSteps = [
  { step: '01', title: '提交线索', text: '通过任一渠道发送文字、聊天记录或视频素材。' },
  { step: '02', title: '分类筛选', text: '编辑按娱乐瓜、网红历史、明星八卦、素人爆料归档。' },
  { step: '03', title: '交叉核实', text: '对时间、地点与来源做比对，标注可确认的部分。' },
  { step: '04', title: '整理曝光', text: '形成时间线或快讯流发布，让线索有机会被看到。' },
];